import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Category, SRouterLinkWithHrefDirective, TranslatePipe } from '@speedy/core';

@Component({
  selector: 'app-autocomplete-category',
  templateUrl: './autocomplete-category.component.html',
  styleUrls: ['./autocomplete-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SRouterLinkWithHrefDirective, TranslatePipe, AsyncPipe],
})
export class AutocompleteCategoryComponent {
  @Input() categories!: Category[];

  @Output() toggleAutocomplete = new EventEmitter<void>();
}
